<template>

  <div id="datadetail">
    <div>
        <div class="large-12 medium-12 small-12 columns"><p></p>
          <h2>ZOBRAZUJEM: {{ readMsisdn }}</h2>
          <hr> </div>
        <datainfo :states="states" :productdetail="productdetail" :tplData="tplData" :filterBouquet="filterBouquet" :typeExists="typeExists"></datainfo>
        <div class="large-12 medium-12 small-12 columns" v-if="baseView.hasMoreData">
          <hr/>
          <img class="leftIco inline" src="graphics/ico_phone.png" /><span class="midleLabel inline fet">Vaše ďalšie balíčky</span>

          <div v-for="bq in baseView.nextPacks" :key="bq.name">
            <div class="row">
                <div class="large-12 medium-12 small-12 columns">
                    <div class="left cre-detail"><strong> {{ pkgNameRead(bq.name) }} </strong></div>
                </div>
            </div>
            <div class="progress-bar" v-if="bq.hasPg && !bq.dataInfinite">
                <div class="vonkajsi">
                    <div class="vnutorny shadow" v-bind:style="{ width: 100 - nextPercentage(bq.value, bq.maxSize) + '%' }"> <span class="inner-text text-left">Prenesené z voľných</span> </div>
                    <div class="vnutorny-right" v-bind:style="{ width: nextPercentage(bq.value, bq.maxSize) + '%' }"> <span class="inner-text text-right-in">{{ orchDataConsumption(bq.maxSize, bq.value) }}</span>
                </div>
            </div> <span class="inner-text text-left-out">Prenesené z voľných</span> <span class="inner-text text-right">{{ orchDataConsumption(bq.maxSize, bq.value) }}</span> </div>
            <div class="progress-bar" style="position:relative;"  v-if="bq.hasPg && bq.dataInfinite"><span class="inner-text text-right-in">neobmedzene</span>
                <div class="vnutorny" style="width: 51%">
                    <div class="opacity-grad"><span class="inner-text text-left-inf">Internet</span></div>
                </div>
            </div>            

            <div v-if="!bq.hasPg" class="row">
              <div class="large-12 medium-12 small-12 columns">
                <span class="inline cre-detail">Zostávajúce voľné dáta</span>
                <span class="right">{{ (Math.round(bq.value / 10.24) / 100).toString().replace(/\./, ',') + " MB" }}</span>
              </div>
             </div>
              <div class="row">
              <div class="large-12 medium-12 small-12 columns">
                <span class="inline cre-detail">Platí do</span>
                <span class="right">{{moment(bq.endDate).format('D.M.YYYY H:mm')}}</span>
              </div>
              </div>
              <div v-if="bq.prolongable">
                  <span class="inline cre-detail">Automatické predĺženie</span>
                  <span class="right">{{ showProl(bq.nextChargeDate).text }}</span>
              <a class="actions action" v-if="showProl(bq.nextChargeDate).bool" v-on:click="states.creditActionView = true, states.creditAction.type = 'stop', states.creditAction.command = bq.name">Vypnúť automatické predĺženie</a>                        
              </div>
            </div>
            </div>
        </div>      
        <div class="large-12 medium-12 small-12 columns"><p>&nbsp;</p>
        <hr>                            
            <router-link to="/balicky"><span class="inline mActive fet">PONUKA DOPLNKOVÝCH BALÍČKOV</span>
            <img class="rightIco right inline" src="graphics/ico_arrow_next.png"/>
            </router-link>
        <p></p>
        <hr>         
        </div>
       </div>
</template>

<script>
import moment from 'moment'
import { orchDataConsumption } from '@/services'
import Datainfo from '@/components/datainfo'
import pkgDef from '@/assets/js/pkgDef'
import Activations from '@/components/balickyaction'

export default {
  name: 'detail',
  props: ['productdetail', 'tplData', 'states', 'filterBouquet', 'typeExists'],
  components: {
    Datainfo
  },
  data () {
    return {
      msg: 'Datainfo',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      baseView: {
        add200: false, add300: false, pBar: true, pgPercentage: 0, pgVal: '', addToGiga: false, stopProlong: false, pgLeftText: "Internet", prolState: "zapnuté",
        gigaValidity: moment(this.productdetail.timeStamp).format('D.M.YYYY') + ' 23:59', prolVisible: false, bucketRest: "0 MB", hasMoreData: false, nextPacks: [], addTextGiga: "Dokúpiť 500 MB za 1 €"
      },
      dataTitle: "Internet v mobile na deň za " + moment(this.productdetail.timeStamp).format('D.M.YYYY'),
      namesMap: {"GIGA1W":"Raz Giga", "GIGA1M":"Vždy Giga", "GIGA2":"Vždy 2 Giga", "StreamOn Data Unlmtd":"Stream On", "StreamOn Data 200":"Stream On 200 MB", "GIGA6":"Dáta na rok 6GB", "GIGA24":"Dáta na rok 24GB", "GIGADEN":"Giga Deň",
      "SW Data":"Dáta pre blízkych", "Magenta Data":"Darované dáta z Magenta 1", "GIGAZIMNY":"Giga akcia", "GIGA4":"4 Giga akcia", "GIGA3":"Vždy Giga (1,5 + 1,5 GB)", "GIGA5":"Vždy 2 Giga (2,5 + 2,5 GB)"}, 
      streamOnDiv: "",
      chatDiv: "",
      socialDiv: "",
      pkgDef: pkgDef.tkarta,
      orchDataConsumption: orchDataConsumption,
      moment: moment
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true 
    that.states.datadetailView = false
    }

    if (_.isObject(this.tplData.package.name)) {
      _.assign(this.namesMap, this.tplData.package.name)
    }

    var nextPacks = []

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = (dpIdent.bucketSize || 1) }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if ((dpIdent.buckets.name.indexOf("SURF1") === -1) && (dpIdent.buckets.endDate) && (dpIdent.buckets.name !== that.$store.state.currDataPackage)) {
        if (dpIdent.buckets.nextChargeDate !== undefined) {
          thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
        } else { thisDataPackage[0]['nextChargeDate'] = false }
        this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageDC' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageDC' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = (dpIdent.bucketSize || 1) }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if ((dpIdent.buckets.endDate) && (dpIdent.buckets.name !== that.$store.state.currDataPackage)) {
        if (dpIdent.buckets.nextChargeDate !== undefined) {
          thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
        } else { thisDataPackage[0]['nextChargeDate'] = false }
        this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)){
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage5' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage5' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: true }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)) {
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MagentaDataPackage' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MagentaDataPackage' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)){
          thisDataPackage[0]['nextChargeDate'] = false
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageBOND' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageBOND' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: false }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage) && (dpIdent.buckets.value != "") && (dpIdent.buckets.value != 0)){
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' }))) {
      var dpIdent = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' })[0]
      if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = dpIdent.bucketSize }
      var thisDataPackage = [{ name: dpIdent.buckets.name, value: dpIdent.buckets.value, endDate: dpIdent.buckets.endDate, maxSize: dpIdent.bucketSize, hasPg: true, dataInfinite: true }]
      if (dpIdent.buckets.endDate && (moment(this.productdetail.timeStamp) < (moment(dpIdent.buckets.endDate))) && (dpIdent.buckets.name !== that.$store.state.currDataPackage)){
          if (dpIdent.buckets.nextChargeDate !== undefined) {
            thisDataPackage[0]['nextChargeDate'] = dpIdent.buckets.nextChargeDate
          } else { thisDataPackage[0]['nextChargeDate'] = false }
          this.baseView.nextPacks = _.concat(this.baseView.nextPacks, thisDataPackage)
      }
    }

    if (!_.isEmpty(this.filterDataBouquet())) {
      var that = this
      _.forEach((this.filterDataBouquet()), function(bq){
        if ((bq.name !== "StreamOn Data Unlmtd") && (bq.name !== that.$store.state.currDataPackage)) {
          var nextChargeDate = false
          if (bg.nextChargeDate !== undefined) {
            nextChargeDate = bg.nextChargeDate
          }
          var thisDataPackage = [{ name: bq.name,  value: bq.value, endDate: bq.endDate, hasPg: false, nextChargeDate: nextChargeDate }]
          that.baseView.nextPacks = _.concat(that.baseView.nextPacks, thisDataPackage)
        }
      })
    } 

    _.forEach(that.pkgDef, function(v,k){
      _.forEach(that.baseView.nextPacks, function(vn,kn){
        if (v.offerBName == vn.name) {
          vn.prolongable = v.prolongable
          vn.stopProl = v.stopProl
        }
      })      
    })

    if (!_.isEmpty(this.baseView.nextPacks)) {
      this.baseView.hasMoreData = true
    }
    this.$store.commit('setOverride', true);
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    }
  }, 
  methods: {
      filterDataBouquet: function () {
        var that = this
        var targetObj = {}, res = [], namesList = ['StreamOn Data 200', 'SW Data', 'StreamOn Data Unlmtd']
        var wallets = this.productdetail.product.subscriberWallets
        if (!Array.isArray(wallets)) {
          wallets = [wallets]
        }
        wallets.forEach(function(v){
          if (v.type === undefined) {
            targetObj = v;
          }
        })
        if (!Array.isArray(targetObj.buckets)) {
          targetObj.buckets = [targetObj.buckets]
        }
        targetObj.buckets.forEach(function(tv){
          if (namesList.indexOf(tv.name) !== -1) {
            if ((moment(that.productdetail.timeStamp) < moment(tv.endDate)) && (tv.value >= 1500)) {
                res.push(tv)
            }
          }
        })
        var mOrder = ['GIGAZIMNY', 'StreamOn Data 200', 'SW Data', 'StreamOn Data Unlmtd']
        res.sort(function (a, b) {
							var nameB = mOrder.indexOf(a['name']),
							    nameA = mOrder.indexOf(b['name'])
							if (nameA < nameB) {
								return 1;
							}
							if (nameA > nameB) {
								return -1;
							}
							return 0;
						});
        return res
      },
      nextPercentage: function(val, max) {
      var checkPerc = (val / max) * 100
      var res = checkPerc
      if (checkPerc < 0)
        {
          res = 0
        }
      if (checkPerc > 100)
        {
          res = 100
        }
      return res  
      },
      pkgNameRead: function(orig) {
        var res = orig;
        if ((/30d_1gb/i).test(orig)) {
          res = "30D_1GB"
        }
        if ((/30d_3gb/i).test(orig)) {
          res = "30D_3GB"
        }
        if ((/30d_4gb/i).test(orig)) {
          res = "30D_4GB"
        }
        if ((/30d_5gb/i).test(orig)) {
          res = "30D_5GB"
        }
        if ((/30d_6gb(?!x)/i).test(orig)) {
          res = "30D_6GB"
        }
        if ((/30d_6gbx/i).test(orig)) {
          res = "30D_6GBx"
        }
        if ((/30d_10gb(?!free)|30d_10gb(?!x)/i).test(orig)) {
          res = "30D_10GB"
        }
        if ((/30d_10gbx/i).test(orig)) {
          res = "30D_10GBx"
        }
        if ((/30d_10gbfree/i).test(orig)) {
          res = "30D_10GBFREE"
        }
        if ((/10d_unltd/i).test(orig)) {
          res = "10D_UnLtd"
        }
        if ((/10d_chat/i).test(orig)) {
          res = "10D_CHAT"
        }
        if ((/10d_social/i).test(orig)) {
          res = "10D_SOCIAL"
        }
        if ((/free data social/i).test(orig)) {
          res = "FD-SOCIAL"
        }
        if ((/free data chat/i).test(orig)) {
          res = "FD-CHAT"
        }
        if ((/10d_1gb/i).test(orig)) {
          res = "10D_1GB"
        }
        if ((/freecalls21/i).test(orig)) {
          res = "FreeCalls21N"
        }
        if ((/giga24/i).test(orig)) {
          res = "GIGA24"
        }
        if ((/dc300/i).test(orig)) {
          res = "DC300"
        }
        if ((/giga6/i).test(orig)) {
          res = "GIGA6"
        }
        if ((/giga2(?!4)/i).test(orig)) {
          res = "GIGA2"
        }
        if ((/giga1(?!w)/i).test(orig)) {
          res = "GIGA1M"
        }
        if ((/giga1w/i).test(orig)) {
          res = "GIGA1W"
        }
        if ((/giga4/i).test(orig)) {
          res = "GIGA4"
        }
        if ((/giga3/i).test(orig)) {
          res = "GIGA3"
        }
        if ((/giga5/i).test(orig)) {
          res = "GIGA5"
        }
        return this.namesMap[res] || res
      },
      showProl: function(nextR) {
        var res = { text: 'vypnuté', bool: false }
        if (nextR !== false) {
          res.text = 'zapnuté'
          res.bool = true
        }
        return res
      }
    }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

</style>
